import { render, staticRenderFns } from "./AdStrategyFields.vue?vue&type=template&id=10843ad5&scoped=true"
import script from "./AdStrategyFields.vue?vue&type=script&lang=js"
export * from "./AdStrategyFields.vue?vue&type=script&lang=js"
import style0 from "./AdStrategyFields.vue?vue&type=style&index=0&id=10843ad5&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10843ad5",
  null
  
)

export default component.exports